import React, { useState, useEffect } from "react";
// import "./DepartmentFormEdit.css";
// import { Form,Button } from "react-bootstrap";
import { Form, Button, Col, Row } from "react-bootstrap";
import axios from "axios";

function DepartmentForm(props) {
  const [DepartmentData, setDepartmentData] = useState(
    props.editData["DepartmentName"]
  );
  const [companyInfo, setCompanyInfo] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [headsData, setHeadsData] = useState([]);

  const onChange = (e) => {
    setDepartmentData(e.target.value);
  };

  const loadCompanyInfo = () => {
    axios
      .get("https://almawridems.javedahmadghamidi.com/api/ems/company", {
        headers: {
          authorization: localStorage.getItem("token") || "",
        },
      })
      .then((response) => {
        setCompanyData(response.data);

        // portalsData=portalsData.filter((data)=>data["Status"]===1);
        setCompanyInfo(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const loadHeadsInfo = () => {
    axios
      .get("https://almawridems.javedahmadghamidi.com/api/ems/headsofDepts", {
        headers: {
          authorization: localStorage.getItem("token") || "",
        },
      })
      .then((response) => {
        setHeadsData(response.data);
        setCompanyInfo(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    console.log(props.editData);
    loadCompanyInfo();
    loadHeadsInfo();
  }, []);
  return (
    <div>
      <h2 id="role-form-title">Edit Department Details</h2>

      <div id="role-form-outer-div">
        <Form
          id="form"
          onSubmit={(e) => props.onDepartmentEditUpdate(props.editData, e)}>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Company
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control as="select" name="country" required>
                <option value="" disabled selected>
                  Select your option
                </option>
                {companyData.map((data, index) => (
                  <option
                    value={data["_id"]}
                    selected={
                      props.editData["company"][0]["_id"] === data["_id"]
                    }>
                    {data["CompanyName"]}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              HOD
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control as="select" name="country" required>
                <option value="" disabled selected>
                  Select Head of Department
                </option>
                {headsData.map((data, index) => (
                  <option value={data["_id"]}>
                    {data["FirstName"] + "-" + data["LastName"]}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Department
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                type="Text"
                placeholder="Department"
                name="DepartmentName"
                required
                value={DepartmentData}
                onChange={(value) => onChange(value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} id="form-submit-button">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button type="submit">Update</Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-cancel-button">
            <Col sm={{ span: 10, offset: 2 }} id="form-cancel-button-inner">
              <Button type="reset" onClick={props.onFormEditClose}>
                cancel
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}

export default DepartmentForm;
